module.exports = __webpack_public_path__ + "img/PETN-Melting-Onset-Temperatures-min.b0fedc5d.png";